(function () {
  const filterBars = document.querySelectorAll('[data-films-library-filters]');

  filterBars.forEach((bar) => {
    const scope = bar.dataset.filterScope || 'films-library';
    const cards = Array.from(document.querySelectorAll(`[data-filter-scope="${scope}"]`));
    const count = bar.querySelector('[data-films-count]');
    const chips = Array.from(bar.querySelectorAll('[data-filter-group]'));
    const params = new URLSearchParams(window.location.search);
    const groups = [...new Set(chips.map((chip) => chip.dataset.filterGroup).filter(Boolean))];
    const state = groups.reduce((nextState, group) => {
      nextState[group] = params.get(group) || 'all';
      return nextState;
    }, {});

    const apply = () => {
      let visible = 0;

      cards.forEach((card) => {
        const shouldShow = groups.every((group) => {
          const active = state[group] || 'all';
          const cardValues = (card.dataset[group] || '').split(',').filter(Boolean);
          return active === 'all' || cardValues.includes(active);
        });

        card.hidden = !shouldShow;
        card.classList.toggle('is-hidden', !shouldShow);
        if (shouldShow) visible += 1;
      });

      chips.forEach((chip) => {
        const group = chip.dataset.filterGroup;
        const value = chip.dataset.filterValue || 'all';
        const active = state[group] === value;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (count) {
        count.textContent = visible;
      }
    };

    const syncUrl = () => {
      const nextParams = new URLSearchParams(window.location.search);
      groups.forEach((group) => {
        state[group] === 'all' ? nextParams.delete(group) : nextParams.set(group, state[group]);
      });
      const query = nextParams.toString();
      window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
    };

    chips.forEach((chip) => {
      chip.addEventListener('click', (event) => {
        event.preventDefault();
        const group = chip.dataset.filterGroup;
        if (!group) return;
        if (chip.dataset.filterReset === 'all') {
          groups.forEach((item) => {
            state[item] = 'all';
          });
        } else {
          state[group] = chip.dataset.filterValue || 'all';
        }
        syncUrl();
        apply();
      });
    });

    apply();
  });
})();
